export default "__VITE_ASSET__oTJeXQPO__"